import { FacilityService } from 'src/app/core/services/facility.service';
import { initLaasPortalVersion, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { GlobalConstants } from './../constants/global-constants.constant';
import { LaasConstants } from './../constants/laas-constants.constant';
import { CommonDataService } from './common-data.service';

@Injectable({
  providedIn: 'root'
})
export class LaasSettingService {

  private timezone: string;

  constructor(
    private localStorageService: LocalStorageService,
    private facilityService: FacilityService) {

    this.timezone = '';

    const facilityVal = this.getOrSetDefault(
      LaasConstants.facilityKey,
      LaasConstants.defaultFacility
    );
    this.initTimeZone(facilityVal);

    this.getOrSetDefault(
      GlobalConstants.languageKey,
      GlobalConstants.defaultLanguage
    );
  }

  private getOrSetDefault(key: string, defaultValue: string): string {
    let value = this.localStorageService.getItem(key);
    if (isNullOrEmpty(value)) {
      value = defaultValue;
      this.localStorageService.setItem(key, value);
    }
    return value;
  }

  get facility(): string {
    const value = this.localStorageService.getItem(LaasConstants.facilityKey) ?? '';
    return value;
  }

  set facility(value: string) {
    this.localStorageService.setItem(LaasConstants.facilityKey, value);
    this.initTimeZone(value);
  }

  get language(): string {
    const value = this.localStorageService.getItem(GlobalConstants.languageKey) ?? GlobalConstants.defaultLanguage;
    return value;
  }

  set language(value: string) {
    this.localStorageService.setItem(GlobalConstants.languageKey, value);
  }

  get facilityTimeZone(): string {
    return this.timezone;
  }

  initTimeZone(facility: string): void {
    this.facilityService.getTimeZone(facility)
    .subscribe({
      next: (result: string) => {
        this.timezone = result ?? '';
      }
    });
  }
}
